import { createContext } from 'react';

const NhlMatchupContext = createContext({
  // isFetching: false,
  id: null,
  matchup: null,
});

export default NhlMatchupContext;
